// Starter songbook for Jianpu Studio — public-domain melodies written in the
// plain-text jianpu format (docs/jianpu-format.md). All movable-do: the
// EasyPlay's transpose dial picks the sounding key, button 1 is always do.
// A few are lightly simplified so they sit inside the instrument's two
// octaves and its rhythm stays friendly — those say so in their title.

import { parseJianpu } from "./jianpu";

export const STARTER_SONGS = [
  {
    id: "scale-warmup",
    text: `title: Two-Octave Warm-up
key: 1=C
time: 4/4
tempo: 80

// every big button once, up and back down
1 2 3 4 | 5 6 7 1' |
2' 3' 4' 5' | 6' 7' 1'' - |
1'' 7' 6' 5' | 4' 3' 2' 1' |
7 6 5 4 | 3 2 1 - |`,
  },
  {
    id: "twinkle",
    text: `title: Twinkle Twinkle Little Star
key: 1=C
time: 4/4
tempo: 100

1 1 5 5 | 6 6 5 - |
4 4 3 3 | 2 2 1 - |
5 5 4 4 | 3 3 2 - |
5 5 4 4 | 3 3 2 - |
1 1 5 5 | 6 6 5 - |
4 4 3 3 | 2 2 1 - |`,
  },
  {
    id: "hot-cross-buns",
    text: `title: Hot Cross Buns
key: 1=C
time: 4/4
tempo: 96

3 2 1 - | 3 2 1 - |
1_ 1_ 1_ 1_ 2_ 2_ 2_ 2_ | 3 2 1 - |`,
  },
  {
    id: "mary-lamb",
    text: `title: Mary Had a Little Lamb
key: 1=C
time: 4/4
tempo: 104

3 2 1 2 | 3 3 3 - |
2 2 2 - | 3 5 5 - |
3 2 1 2 | 3 3 3 3 |
2 2 3 2 | 1 - - - |`,
  },
  {
    id: "frere-jacques",
    text: `title: Frère Jacques
key: 1=F
time: 4/4
tempo: 108

// up an octave so "1' 5 1'" stays on the buttons — the EasyPlay's
// lowest note is 1, so melodies that dip below do live in octave 2
1' 2' 3' 1' | 1' 2' 3' 1' |
3' 4' 5' - | 3' 4' 5' - |
5'_ 6'_ 5'_ 4'_ 3' 1' | 5'_ 6'_ 5'_ 4'_ 3' 1' |
1' 5 1' - | 1' 5 1' - |`,
  },
  {
    id: "ode-to-joy",
    text: `title: Ode to Joy
key: 1=G
time: 4/4
tempo: 112

// up an octave: the B section dips to sol-below-do, and the EasyPlay's
// lowest note is 1
3' 3' 4' 5' | 5' 4' 3' 2' |
1' 1' 2' 3' | 3'. 2'_ 2' - |
3' 3' 4' 5' | 5' 4' 3' 2' |
1' 1' 2' 3' | 2'. 1'_ 1' - |
2' 2' 3' 1' | 2' 3'_ 4'_ 3' 1' |
2' 3'_ 4'_ 3' 2' | 1' 2' 5 - |
3' 3' 4' 5' | 5' 4' 3' 2' |
1' 1' 2' 3' | 2'. 1'_ 1' - |`,
  },
  {
    id: "london-bridge",
    text: `title: London Bridge (simplified)
key: 1=D
time: 4/4
tempo: 104

5. 6_ 5 4 | 3 4 5 - |
2 3 4 - | 3 4 5 - |
5. 6_ 5 4 | 3 4 5 - |
2 - 5 - | 3 1 - - |`,
  },
  {
    id: "amazing-grace",
    text: `title: Amazing Grace (simplified)
key: 1=G
time: 3/4
tempo: 84

// up an octave: the pickup is sol-below-do, and the EasyPlay's lowest
// note is 1
5 | 1' - 3'_ 1'_ | 3' - 2' |
1' - 6 | 5 - 5 |
1' - 3'_ 1'_ | 3' - 2' | 5' - - |
3' - 5'_ 3'_ | 1' - 6 | 5 - 5 |
1' - 3'_ 1'_ | 3' - 2' | 1' - - |`,
  },
  {
    id: "happy-birthday",
    text: `title: Happy Birthday (simplified)
key: 1=F
time: 3/4
tempo: 116

// up an octave: the tune starts on sol-below-do, and the EasyPlay's
// lowest note is 1
5_ 5_ | 6 5 1' | 7 - 5_ 5_ |
6 5 2' | 1' - 5_ 5_ |
5' 3' 1' | 7 6 4'_ 4'_ |
3' 1' 2' | 1' - - |`,
  },
];

// Parsed versions, cached once — the texts are trusted (tested) inputs.
export function getStarterSongs() {
  return STARTER_SONGS.map(({ id, text }) => {
    const { song } = parseJianpu(text);
    return { id, text, song };
  });
}

export function getStarterSong(id) {
  return getStarterSongs().find((s) => s.id === id) || null;
}
